import PersonalCenterNav from './src/main';

/* istanbul ignore next */
PersonalCenterNav.install = function(Vue) {
  Vue.component(PersonalCenterNav.name, PersonalCenterNav);
};

export default PersonalCenterNav;
